import React from "react";
import {PlusCircleIcon} from "@heroicons/react/24/solid";
import ProductCodeAutocomplete from "./ProductCodeAutocomplete";

const AddProductSnapshot = ({
                                showNewProductRow,
                                newSnapshot,
                                handleAddProduct,
                                handleCancelProductClick,
                                handleNewSnapshotChange,
                                handleAddProductClick,
                                handleProductSelect,
                                handleCodeChange
                            }) => {
    return (
        <div>
            {
                !showNewProductRow ? (
                    <div className="mt-4 flex space-x-4">
                        {/* Green "+" button for adding a product */}
                        <button
                            onClick={handleAddProductClick}
                            className="bg-[#01ff01] hover:bg-green-600 text-white py-2 px-4 rounded flex items-center"
                        >
                            <PlusCircleIcon className="h-8 w-8"/>
                        </button>

                        {/* Import button (keeping same style) */}
                        <button className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded">
                            Import
                        </button>
                    </div>
                ) : (
                    <div className="mt-4 flex space-x-4">
                        {/* Green checkmark button for Save */}
                        <button
                            onClick={handleAddProduct}
                            className="flex items-center gap-2 bg-gray-200 hover:bg-gray-300 text-[#34495e] font-bold py-2 px-4 rounded transition"
                            title="Save"
                        >
                            <span role="img" aria-label="save">💾</span>
                            Save
                        </button>

                        {/* Red "X" button for Cancel */}
                        <button
                            onClick={handleCancelProductClick}
                            className="flex items-center gap-2 bg-gray-200 hover:bg-gray-300 text-[#34495e] font-bold py-2 px-4 rounded transition"
                        >
                            <span role="img" aria-label="save">❌</span>
                            Cancel
                        </button>
                    </div>
                )
            }
            {
                showNewProductRow && (
                    <div className="mt-4 bg-gray-50 p-4 rounded border">
                        <table className="border-collapse table-auto w-full text-sm rounded border">
                            <thead>
                            <tr className="bg-gray-100">
                                <th className="border-b p-4 pl-8 text-gray-600">Name</th>
                                <th className="border-b p-4 pl-8 text-gray-600">Price</th>
                                <th className="border-b p-4 pl-8 text-gray-600">Currency</th>
                                <th className="border-b p-4 pl-8 text-gray-600">Quantity</th>
                                <th className="border-b p-4 pl-8 text-gray-600">Discount</th>
                                <th className="border-b p-4 pl-8 text-gray-600">Code</th>
                                <th className="border-b p-4 pl-8 text-gray-600">Description</th>
                                <th className="border-b p-4 pl-8 text-gray-600">Type</th>
                                <th className="border-b p-4 pl-8 text-gray-600">Company</th>
                            </tr>
                            </thead>
                            <tbody className="bg-white">
                            <tr>
                                {Object.keys(newSnapshot).filter(f => f !== 'productId').map((field) => (
                                    <td key={field} className="border-b p-4 pl-8 text-gray-700">

                                        {
                                            field === 'currency' || field === 'type' ?
                                                <select
                                                    value={newSnapshot[field]}
                                                    onChange={(e) => handleNewSnapshotChange(field, e.target.value)}
                                                    className="border p-1 rounded w-full"
                                                >
                                                    {field === 'currency' ? (
                                                        <>
                                                            <option value="EUR">EUR</option>
                                                            <option value="RSD">RSD</option>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <option value="VIDEO">VIDEO</option>
                                                            <option value="AUDIO">AUDIO</option>
                                                            <option value="LIGHTING">LIGHTING</option>
                                                            <option value="UNKNOWN">UNKNOWN</option>
                                                        </>
                                                    )}
                                                </select> : null
                                        }

                                        {field === 'code' ? (
                                            <ProductCodeAutocomplete
                                                value={newSnapshot[field]}
                                                onProductSelect={handleProductSelect}
                                                onCodeChange={handleCodeChange}
                                                className="border p-2 rounded w-full mb-2"
                                            />
                                        ) : null}

                                        {field !== 'currency' && field !== 'type' && field !== 'code' ? <input
                                            type={field === 'price' || field === 'discount' || field === 'quantity' ? 'number' : 'text'}
                                            step={field === 'price' || field === 'discount' ? '0.01' : '1'}
                                            key={field}
                                            placeholder={field}
                                            value={newSnapshot[field]}
                                            onChange={(e) => handleNewSnapshotChange(field, e.target.value)}
                                            className="border p-2 rounded w-full mb-2"
                                        /> : null
                                        }
                                    </td>
                                ))}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                )
            }
        </div>
    )
}

export default AddProductSnapshot;